import React from 'react';
import './coaches-picture.css';
import Logo from './wa-sunny';

const CoachesPicture = () =>
    (
        <div className="-wa-help-center__wa-team rounded-circle">
            <Logo />
        </div>
    );

export default CoachesPicture;
